<div class='img-wrapper'>
  <!-- <img src="../../../assets/image/bank/Converse.png" alt="img" /> -->
</div>
<div class="login-wrapper">
  <div class="login">
    <h1>Sign in</h1>
    <ng-template [ngIf]="loginIsValid" [ngIfElse]="error"></ng-template>
    <br>
    <div class="input">
      <label for='username'>Username</label><br>
      <input [(ngModel)]="login.username" type='text' name='username' />
    </div>
    <br>
    <div class="input">
      <label for='password'>Password</label><br>
      <input (keydown.enter)='onSubBtnClick()' [(ngModel)]="login.password" type='password' name='password' />
    </div>
    <br>
    <a (click)="resetPassword()">Forgot Password?</a><br>
    <br>
    <button id='submit' type="submit" class="btn btn-block btn-outline-primary" type='submit'
      (click)='onSubBtnClick()'>Submit</button>
  </div>
</div>
<ng-template #error>
  <div id='error'>
    <b>{{errorMessage}}</b>
  </div>
</ng-template>
